import React, { Component } from "react";
import { connect } from "react-redux";
import * as qs from "query-string";
import { history, isValidStartDate, isValidEndDate } from "../../_helpers";
import { api } from "../../_services";
import MenuBar from "../MenuBar";
import AlertCard from "../AlertCard";
import PrecinctDropdown from "../PrecinctDropdown";
import SeverityCheckBox from "../SeverityCheckBox";
import DateTimePicker from "../DateTimePicker";
import FilterMenuBar from "../FilterMenuBar";
import Pagination from "../Pagination";
import _ from "lodash";
import { pageAlerts, sidebarOff, modalAlert, selectAlerts, deselectAlerts, clearSelectedAlerts } from "../../_actions";
import "react-table/react-table.css";
import "./index.css";
import { Button, Row, Col, form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";

class AllAlertPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: null,
      loading: false,
      filterOpen: false,
      resetFilter: false,
      listLoading: false,
      filtered: false,
      showIDInput: false,
      params: {},
    };
  }

  componentDidMount = () => {
    this.setState(() => {
      return {
        loading: true
      };
    });
    this.props.sidebarOff();
    this.props.pageAlerts();

    if (this.props.location.search) {
      const params = qs.parse(this.props.location.search);
      this.getAllAlert(params);
    } else {
      this.getAllAlert();
    }
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.location.search !== nextProps.location.search && nextProps.location.search === "") {
      this.resetFilter();
    }
  };

  componentDidUpdate() {
    if (this.allTitleCheckbox && this.allContentCheckbox) {
      if (this.areAllAlertsOnPageChecked() === null) {
        this.allTitleCheckbox.indeterminate = true;
        this.allContentCheckbox.indeterminate = true;
      } else {
        this.allTitleCheckbox.indeterminate = false;
        this.allContentCheckbox.indeterminate = false;
      }
    }
  }

  /* Retrieve all alerts */
  getAllAlert = p => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });
    const url = "/api/v1/alerts/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
      this.setState(() => {
        return {
          params: params,
          showIDInput: params.id ? true : false
        };
      });
    } else {
      // clear the url params
      if (this.props.location.search) {
        history.push({
          pathname: this.props.location.pathname,
          search: ""
        });
      }
    }
    const errorMsg = "Unable to retrieve alerts.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      const filtered = this.checkFiltered();
      this.setState(() => {
        return {
          allAlertsList: json.results,
          count: json.count,
          page_size: json.page_size,
          num_pages: json.num_pages,
          current_page: json.current_page,
          loading: false,
          listLoading: false,
          filtered: filtered
        };
      });
    });
  };

  filterAlert = (reset, page) => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });

    // clear selected alerts on filter
    if (!reset && !page) {
      this.props.clearSelectedAlerts();
    }

    const url = "/api/v1/alerts/";
    const params = {
      closed: "",
      alert_type: ""
    };
    if (!reset) {
      if (!this.state.params.id) {
        this.setState(() => {
          return {
            showIDInput: false
          };
        });
      }

      for (const key in this.state.params) {
        if (this.state.params[key] !== "") {
          params[key] = this.state.params[key];
        }
      }

      if (page) {
        params.page = page;
      } else {
        delete params["page"];
      }
    }
    if (this.checkFiltered() || !reset) {
      const errorMsg = "Unable to retrieve alerts.";
      let filtered = false;

      filtered = this.checkFiltered();

      api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
        this.setState(() => {
          return {
            allAlertsList: json.results,
            count: json.count,
            page_size: json.page_size,
            num_pages: json.num_pages,
            current_page: json.current_page,
            loading: false,
            listLoading: false,
            filtered: filtered ? true : false
          };
        });
      });
      this.openFilter(false);
    } else if (reset) {
      this.setState(() => {
        return {
          loading: false,
          filtered: reset ? false : true
        };
      });
    }

    const queryParams = api.queryParams(params);
    if (queryParams) {
      history.push({
        pathname: this.props.location.pathname,
        search: "?" + queryParams
      });
    } else {
      history.push({
        pathname: this.props.location.pathname,
        search: ""
      });
    }
  };

  checkFiltered = () => {
    let filtered = false;
    for (const key in this.state.params) {
      if (Array.isArray(this.state.params[key]) && this.state.params[key].length > 0) {
        filtered = true;
      } else if (this.state.params[key]) {
        filtered = true;
      }
    }
    return filtered;
  };

  toggleAlert = (id) => {
    const { selectedAlertList, selectAlerts, deselectAlerts } = this.props;
    if (selectedAlertList.indexOf(id) < 0) {
      selectAlerts([id]);
    } else {
      deselectAlerts([id]);
    }
  }

  toggleAllAlertsOnPage = () => {
    const { selectedAlertList, selectAlerts, deselectAlerts } = this.props;
    const { allAlertsList } = this.state;

    // check if no alerts toggled -> select all alerts
    if (this.areAllAlertsOnPageChecked() === false) {
      selectAlerts(allAlertsList.map(alert => alert.id));
    } else {
      // check if some or all alerts toggled -> deselect all alerts
      const alertsToRemove = _.intersection(allAlertsList.map(alert => alert.id), selectedAlertList);
      deselectAlerts(alertsToRemove);
    }
  }

  areAllAlertsOnPageChecked = () => {
    const { selectedAlertList } = this.props;
    const { allAlertsList } = this.state;

    if (allAlertsList.length < 1) {
      return false;
    }

    const allAlertsListIds = allAlertsList.map(alert => alert.id);

    const someChecked = _.difference(allAlertsListIds, selectedAlertList).length < allAlertsListIds.length;
    const allChecked = _.difference(allAlertsListIds, selectedAlertList).length === 0;
    // check if no alerts toggled -> false
    // can't check for empty list as selected alerts can come from another page
    if (!someChecked) {
      return false;
    }

    // check if all alerts toggled -> true
    if (allChecked) {
      return true;
    }

    // if some alerts toggled -> indeterminate
    return null;
  }

  createAlertCard = (item, key) => {
    return <AlertCard
      key={key}
      item={item}
      action={this.toggleAlert}
      selectedAlert={this.props.selectedAlertList.indexOf(key) >= 0}
    />;
  };

  renderMainTitle = data => {
    if (!data) {
      return null;
    }

    let areAllAlertsOnPageChecked = this.areAllAlertsOnPageChecked();
    if (areAllAlertsOnPageChecked === null) {
      areAllAlertsOnPageChecked = true;
    }

    return (
      <div>
        <div className="mainTitle">
          <h1>
            Alerts {"(" + this.state.count + ")"}
          </h1>
        </div>
        <div className="titleBtnCon">
          <div className="mergeCon allCheckbox">
            <input
              type="checkbox"
              ref={el => this.allTitleCheckbox = el}
              name="all-alerts-checkbox"
              className="checkbox all-checkbox"
              value='all-alerts-checked'
              onChange={this.toggleAllAlertsOnPage}
              checked={areAllAlertsOnPageChecked}
            />
          </div>
          <div className="mergeCon hidden-md hidden-lg hidden-sm">
            <Button type="button" onClick={() => this.openFilter(true)} bsStyle="primary">
              Filter
            </Button>
          </div>
        </div>
      </div>
    );
  };

  openFilter = opened => {
    if (opened) {
      this.setState(() => {
        return {
          filterOpen: true
        };
      });
    } else {
      this.setState(() => {
        return {
          filterOpen: false
        };
      });
    }
  };

  setId = e => {
    const params = this.state.params;
    params.id = e.target.value;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setStartDate = e => {
    const params = this.state.params;
    params.start_time = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setEndDate = e => {
    const params = this.state.params;
    params.end_time = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setStatus = val => {
    const params = this.state.params;
    params.status = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setSeverity = val => {
    const params = this.state.params;
    params.severity = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setPrecinct = val => {
    const params = this.state.params;
    params.precincts = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  resetFilter = () => {
    this.setState(() => {
      return {
        resetFilter: true,
        params: {},
        showIDInput: false
      };
    });

    // clear selected alerts on filter
    this.props.clearSelectedAlerts();

    this.getAllAlert();
  };

  renderResetBtn = () => {
    if (this.state.filtered === true) {
      return (
        <a className="pull-right link" onClick={() => this.resetFilter()}>
          Reset filters
        </a>
      );
    } else {
      return null;
    }
  };

  renderPagination = () => {
    if (!this.state.listLoading && this.state.count > this.state.page_size) {
      return (
        <Pagination
          count={this.state.count}
          page_size={this.state.page_size}
          num_pages={this.state.num_pages}
          current_page={this.state.current_page}
          action={this.filterAlert}
        />
      );
    } else {
      return null;
    }
  };

  renderIdInput = () => {
    if (this.state.showIDInput) {
      return (
        <FormGroup controlId="formBasicText">
          <ControlLabel>ID</ControlLabel>
          <FormControl
            type="text"
            placeholder="Alert ID"
            name="id"
            value={this.state.params.id}
            onChange={this.setId}
          />
        </FormGroup>
      );
    }
  };

  isValidStartDate = (current) => isValidStartDate(current, this.state.params.end_time)

  isValidEndDate = (current) => isValidEndDate(current, this.state.params.start_time)

  renderMainContent = data => {
    if (!data) {
      return null;
    }

    const alertCardListToRender = [];
    if (data !== undefined && data.length > 0) {
      _.each(data, (item) => {
        alertCardListToRender.push(this.createAlertCard(item, item.id));
      });
    }

    let areAllAlertsOnPageChecked = this.areAllAlertsOnPageChecked();
    if (areAllAlertsOnPageChecked === null) {
      areAllAlertsOnPageChecked = true;
    }


    return (
      <div className="mainContent card-list">
        <Row>
          <Col md={3} mdPush={9}>
            <div className={"panel-div filter-column" + (this.state.filterOpen ? " filterOpen" : "")}>
              <div className="filterTitle">FILTER ALERTS {this.renderResetBtn()}</div>
              <form>
                {this.renderIdInput()}
                <PrecinctDropdown
                  change={this.setPrecinct}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.precincts}
                />
                <DateTimePicker
                  timePeriod="From"
                  changeDate={this.setStartDate}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.start_time}
                  isValidDate={this.isValidStartDate}
                />
                <DateTimePicker
                  timePeriod="To"
                  changeDate={this.setEndDate}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.end_time}
                  isValidDate={this.isValidEndDate}
                />
                <SeverityCheckBox
                  change={this.setSeverity}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.severity}
                />
                <div className="buttonContainer">
                  <Button className="btn-cancel" bsStyle="default" onClick={() => this.openFilter(false)}>
                    Cancel
                  </Button>
                  <Button className="btn-filter" bsStyle="primary" onClick={() => this.filterAlert()}>
                    Filter
                  </Button>
                </div>
              </form>
            </div>
          </Col>
          <Col md={9} mdPull={3}>

            {this.state.listLoading ? (
              <div className="empty-list">
                <div className="loading2" />
              </div>
            ) : null}
            <div className={this.state.listLoading ? "hide" : ""}>
              {alertCardListToRender.length > 0 ? alertCardListToRender : <div className="empty-list">No Result</div>}
            </div>
            {this.renderPagination()}
          </Col>
        </Row>
      </div>
    );
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  render() {
    const data = this.state.allAlertsList;
    if (this.state.loading === false) {
      return (
        <div>
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderMainTitle(data)}
              {this.renderMainContent(data)}
            </div>
          </div>
        </div>
      );
    } else {
      return <div>{this.renderLoadingPage()}</div>;
    }
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const selectedAlertList = state.selectedAlerts.selected;
  return {
    user,
    selectedAlertList
  };
}

export default connect(mapStateToProps, {
  pageAlerts,
  sidebarOff,
  modalAlert,
  selectAlerts,
  deselectAlerts,
  clearSelectedAlerts
})(AllAlertPage);



// WEBPACK FOOTER //
// ./src/_components/AllAlertPage/index.js